import { render, staticRenderFns } from "./StepsProcess.vue?vue&type=template&id=32226660&scoped=true"
import script from "./StepsProcess.vue?vue&type=script&lang=js"
export * from "./StepsProcess.vue?vue&type=script&lang=js"
import style0 from "./StepsProcess.vue?vue&type=style&index=0&id=32226660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32226660",
  null
  
)

export default component.exports